module.exports = "<template> <reference-display if.bind=invoice reference.bind=invoice></reference-display> </template> ";